module.exports = __webpack_public_path__ + "img/31.60e6372f.jpg";